<input #input
  type="radio"
  [attr.aria-labelledby]="inputId + 'radio-label'"
  [name]="name()"
  [attr.id]="inputId"
  [disabled]="disabled()"
  [readOnly]="readOnly()"
  test-id="ms-radio-input"
  (change)="change()"
  [class]="inputClasses()"
/>
<label [id]="inputId + 'radio-label'" [attr.for]="inputId" [attr.tabindex]="0" (blur)="blur()" (click)="click()" [class]="labelClasses()"><ng-content></ng-content></label>
